module.exports = __webpack_public_path__ + "img/3.089b77a8.jpg";